import { PrimaryButton, RetryIcon, SecondaryButton, TickIcon } from '@weareopenr/component-library';
import styles from './PricingSaveSummary.module.scss';
import { FieldValues, UseFormReset } from 'react-hook-form';
import { PRICING_FORM_ID } from 'src/constants';

export const PricingSaveSummary = <TFieldValues extends FieldValues>({
  isSubmitting,
  reset,
  totalChanges,
  form = PRICING_FORM_ID,
}: {
  isSubmitting: boolean;
  reset: UseFormReset<TFieldValues>;
  totalChanges: number;
  form?: string;
}) => {
  return (
    <div className={styles['save-container']}>
      <SecondaryButton colour="tomato" buttonStyle="ghost" icon={RetryIcon} onClick={() => reset()}>
        Reset Changes
      </SecondaryButton>
      <PrimaryButton type="submit" form={form} icon={TickIcon} loading={isSubmitting}>
        {`Save Changes (${totalChanges})`}
      </PrimaryButton>
    </div>
  );
};
